import {Directive, HostListener, Input, OnInit} from '@angular/core';
import {AppConfigService} from '@ox/utils';

/*
  ng2: Dev Notes: This directive now expects the input to be a formControl (Reactive Forms).
  The error html for BR needs to reference the respective *ngIf="<formGroupName>.controls.<formControlName>.errors?.invalid"
*/

@Directive({
  selector: '[oxValidateHelper]'
})
export class ValidationHelperDirective implements OnInit {
  @Input('oxValidateHelper') declaredType = '';
  public formFieldAttributes = this.appConfig.fieldAttributes;
  private phoneNumberMaxLength = 0;
  private taxIdMaxLengthDigits = 0;
  private allowedCharacters = / /;
  private maxIntegers = 0;
  private specialCharactersPatternSource = '';
  private specialCharactersPattern = '';

  constructor(private appConfig: AppConfigService) {
  }

  ngOnInit() {
    this.phoneNumberMaxLength =
      this.formFieldAttributes.phoneNumber?.maxlengthDigits;
    this.taxIdMaxLengthDigits = this.formFieldAttributes.taxId?.maxlengthDigits;
    this.allowedCharacters =
      this.formFieldAttributes.allowedCharacters[this.declaredType];
    // this.specialCharactersPattern =
    //   this.formFieldAttributes.serviceHistory?.specialCharacters?.pattern;
    // this.specialCharactersPatternSource =
    //   this.formFieldAttributes.serviceHistory?.specialCharacters?.pattern?.source;
    this.maxIntegers =
      this.formFieldAttributes?.serviceHistory?.serviceCost?.maxIntegers;
  }

  /*
    Prevents certain characters from regex from being entered
  */
  @HostListener('keypress', ['$event'])
  onChange(event: KeyboardEvent) {
    if (!event || !event.target) {
      return;
    }
    // check if allowed characters are specified in field attributes, then validate against them
    if (!!this.allowedCharacters && this.declaredType !== 'password') {
      this.eventKeyPress_evaluateRegex(event, this.allowedCharacters);
    }
  }

  /*
    Removes  illegal characters pasted in, and if BR market checks taxId and changes error state
  */
  @HostListener('blur', ['$event'])
  onBlur(event: Event) {
    const target = event.target as HTMLInputElement;
    // Removed the markedTouched function that step scope variable touched to
    // to true. This property gets set automatically via the reactive forms formControl
    if (!event || !target || !target.value) {
      return;
    }
    if (
      this.declaredType === 'numeric' ||
      this.declaredType === 'lettersAposHyphen' ||
      this.declaredType === 'lettersAposHyphenSpace' ||
      this.declaredType === 'phone' ||
      this.declaredType === 'addressCharacters' ||
      this.declaredType === 'ssid'
    ) {
      this.eventOnBlur_evaluateRegex(event, this.allowedCharacters);
    }
  }

  /*
    Prevents typing certain declaredType based formats/lengths
  */
  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    if (this.declaredType === 'phone') {
      this.eventOnInput_phoneOnly(event, this.phoneNumberMaxLength);
    } else if (this.declaredType === 'money') {
      this.eventOnInput_moneyOnly(event, this.maxIntegers);
    } else if (this.declaredType === 'taxId') {
      this.eventOnInput_taxIdOnly(event, this.taxIdMaxLengthDigits);
    }
  }

  /*
   * Validates input matches the input types regex
   */
  eventKeyPress_evaluateRegex(event: KeyboardEvent, regex: RegExp) {
    const key = event.which ? event.which : event.keyCode;
    if (!regex.test(String.fromCharCode(key))) {
      event.preventDefault();
    }
  }

  eventOnBlur_evaluateRegex(event: Event, regex: RegExp) {
    const regex2 = new RegExp('[^' + regex.source.replace('[', ''));
    const target = event.target as HTMLInputElement;
    //wipe field if there are any illegal characters pasted
    if (regex2.test(target?.value)) {
      target.value = '';
    }
  }

  eventOnInput_phoneOnly(event: Event, phoneDigitsMax: number) {
    const target = event.target as HTMLInputElement;
    //prevent from typdeclaredTypeing a longer phone
    if (this.declaredType === 'phone') {
      const key = target.value.slice(-1);
      let maxlength: number | string = target.value.replace(
        /\+|\(|\)|-|\s/g,
        ''
      );
      maxlength = maxlength.length;
      const digits = /[0-9]/;
      if (maxlength > phoneDigitsMax && digits.test(key)) {
        target.value = target.value.slice(0, -1);
      }
    }
  }

  eventOnInput_taxIdOnly(event: Event, taxIdDigitsMax: number) {
    const target = event.target as HTMLInputElement;
    //prevent from typing a longer phone
    if (this.declaredType === 'taxId') {
      const key = target.value.slice(-1);
      let maxlength: string | number = target.value.replace(/\.|-|\s/g, '');
      maxlength = maxlength.length;
      const digits = /[0-9]/;
      if (maxlength > taxIdDigitsMax && digits.test(key)) {
        target.value = target.value.slice(0, -1);
      }
    }
  }

  eventOnInput_moneyOnly(event: Event, moneyIntMax: number) {
    //prevent from typing a longer cost
    const target = event ? (event?.target as HTMLInputElement) : null;
    const period = target ? target?.value?.replace(/[0-9]/g, '') : null;
    if (period === '') {
      const key = target?.value.slice(-1);
      let integer: string | number | undefined = target?.value.split(/\./g)[0];
      integer = integer ? Number(integer?.length) : 0;
      const digits = /[0-9]/;
      if (integer > moneyIntMax && key && digits.test(key) && target?.value) {
        target.value = target?.value.slice(0, -1);
      }
    }
  }
}
